<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div mat-dialog-content>
      <div *ngFor="let field of fields">
        <app-dynamic-form-field
          [field]="field"
          [form]="form"
        ></app-dynamic-form-field>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button [mat-dialog-close]>
        {{ "DASHBOARD.EDIT_WIDGET.CANCEL" | translate }}
      </button>

      <button
        mat-raised-button
        color="primary"
        class="right"
        type="submit"
        [disabled]="!form.valid"
        [mat-dialog-close]="getPayLoad"
        cdkFocusInitial
      >
        {{ "DASHBOARD.EDIT_WIDGET.ACCEPT" | translate }}
      </button>
    </div>
  </form>
</div>
<!-- [disabled]="!form.valid" -->
